import React from 'react';
import { Link } from 'react-router-dom';

function Treatments() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .treatments-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Advanced Medical Treatments in Delhi NCR: Premium Private Specialty Care Guide
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          When facing complex health conditions that require specialized surgical or diagnostic intervention, access to elite clinical care shouldn't be restricted by long waiting lists or high domestic premiums. The Delhi National Capital Region (NCR)—encompassing New Delhi, Gurgaon, and Noida—stands as a premier international medical hub, offering a world-class network of private multi-specialty corporate hospitals.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By compiling comprehensive clinical pathways on independent research networks like <strong>Medical Trip World</strong>, international patients can explore cutting-edge treatment options, evaluate corporate hospital systems, and analyze estimated global cost benchmarks safely.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Private Treatment Cost Estimates & Toolkits →
        </Link>
      </div>

      {/* SECTION 1: DETAILED SPECIALTY OVERVIEW - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Core Medical Specialties and Private Surgical Options
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Unlike state-funded public municipal clinics, private hospital networks across Delhi NCR continuously deploy next-generation medical technologies to execute highly successful therapeutic treatments:
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.15rem', fontWeight: '700' }}>🫀 Advanced Cardiology</h3>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              Elite private hubs deploy hybrid catheterization labs to complete minimal-access coronary angioplasty, complex heart valve reconstructions, and high-precision Coronary Artery Bypass Grafting (CABG) to ensure optimal long-term structural recovery.
            </p>
          </div>

          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.15rem', fontWeight: '700' }}>🦵 Precision Orthopedics</h3>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              Private centers utilize computer-navigated 3D optical tracking devices to complete unilateral or bilateral total knee and hip joint replacements, maximizing ligament balance and long-term implant survival.
            </p>
          </div>

          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.15rem', fontWeight: '700' }}>🎗️ Integrated Oncology</h3>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              Corporate cancer wings provide advanced multidisciplinary care boards specialized in CyberKnife stereotactic radiosurgery, highly targeted immunotherapies, and sterile bone marrow transplantation protocols.
            </p>
          </div>

        </div>
      </section>

      {/* SECTION 2: ESTIMATED COST MATRIX - SAFELY WRAPPED */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Estimated Treatment Cost Savings Analysis
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Evaluating cross-border expenditures is a foundational pre-planning benchmark for medical tourists. The figures below reflect estimated cost points gathered from public registries, comparing private healthcare markets globally:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Estimated Specialty Treatment Cost Indexes (USD):</h3>
          
          {/* Scroll Protective Wrapper Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Procedure Description</th>
                  <th style={{ padding: '10px 8px' }}>United States (Private)</th>
                  <th style={{ padding: '10px 8px' }}>United Kingdom (Private)</th>
                  <th style={{ padding: '10px 8px', color: '#28a745' }}>Global Range (Delhi NCR Private)</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Heart Bypass (CABG)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$120,000+</td>
                  <td style={{ padding: '10px 8px' }}>$70,000+</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$6,500 - $9,000</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Total Knee Replacement (Single)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$35,000+</td>
                  <td style={{ padding: '10px 8px' }}>$16,000+</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$4,500 - $6,000</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Bone Marrow Transplant (Autologous)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$150,000+</td>
                  <td style={{ padding: '10px 8px' }}>$70,000+</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$15,000 - $22,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ margin: '10px 0 0 0', fontSize: '0.8rem', color: '#666', lineHeight: '1.5' }}>
            <em>*Data Compliance Notice: These financial statistics serve informational reference purposes only. Final pricing quotes depend completely on individual private facility selection, hardware model specifications, required length of ICU stay, and advanced diagnostic lab panels.</em>
          </p>
        </div>
      </section>

      {/* SECTION 3: SAFETY & STRUCTURAL QUALITY AUDITING - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Independent Quality Checkpoints for Clinical Vetting
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates strictly as an open informational venue and independent index, we advise international families to self-verify chosen corporate clinics by checking these operational baselines:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Active International Accreditations</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Cross-reference active public safety registries to confirm that a private facility holds current Joint Commission International (JCI) or national NABH equivalent stamps to guarantee strictly monitored surgical hygiene protocols.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Senior Consultant Profiles</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Confirm that your primary surgeon holds verified post-graduate training lines or senior board certifications from recognized international surgical societies or Western medical boards.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Private Specialty Care Directory
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are international patients subjected to long waitlists at private hospitals in India?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Premium corporate private networks across New Delhi and Gurgaon do not utilize waitlists for international passport holders. Once pre-travel medical histories are validated and a specialized Medical Visa is obtained, physical diagnostics and clinical operations can begin within 24 to 48 hours of landing.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are foreign laboratory records accepted by private Indian clinical teams?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes, high-resolution pathology logs, MRI/CT scans, and diagnostic data translated into English are readily analyzed by consulting specialists. However, localized surgeons routinely order quick baseline validation panels to confirm exact parameters before executing invasive procedures.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World maintain commercial agreements with specific specialty clinics?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not provide clinical interventions, manage surgical teams, or maintain formal corporate partnerships or Memorandums of Understanding (MOUs) with any private hospital system. All financial quotes, clinical evaluation reviews, and therapeutic care obligations exist exclusively between the patient and their self-selected healthcare professional.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="treatments-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="treatments-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Treatments;